import { render, staticRenderFns } from "./ProcedureBuilder.vue?vue&type=template&id=84365176&"
import script from "./ProcedureBuilder.vue?vue&type=script&lang=js&"
export * from "./ProcedureBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureBuilder.vue?vue&type=style&index=0&id=84365176&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports